import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

import ButtonBase from '../ButtonBase';

const Fab = ({ children, size, ...props }) => (
  <FabComponent size={size} {...props}>
    <Label>{children}</Label>
  </FabComponent>
);

Fab.propTypes = {
  children: PropTypes.node,
  size: PropTypes.oneOfType([
    PropTypes.number.isRequired,
    PropTypes.shape({
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired
    }).isRequired
  ])
};

const FabComponent = styled(ButtonBase)`
  box-sizing: border-box;
  min-height: 36px;
  min-width: 0;
  padding: 0;
  border-radius: 50%;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.3);
  overflow: hidden;

  ${({ size }) => {
    if (typeof size === 'number') {
      return css`
        width: ${size}px;
        height: ${size}px;
      `;
    }

    return css`
      width: ${size.width}px,
      height: ${size.height}px
    `;
  }}
`;

const Label = styled.span`
  width: 100%;
  display: flex;
  justify-content: inherit;
  align-items: inherit;
`;

export default Fab;
